import gql from 'graphql-tag';

const GET_ACCOUNT = gql`
  query InitialQuery($userProfileId: ID) {
    partner(userProfileId: $userProfileId) {
      hasApi
      name
      partnerProfileId
      partnerLogo
      isAftermarketProd
      partnerDynamicsProfileId
    }
    account(userProfileId: $userProfileId) {
      id
      name
      vendorProfileId
      dynamicsAccountId
      primaryContactId
      primaryContactName
      primaryContactPhone
      primaryContactEmail
      accountManagerDynamicsId
      address
      phone
      accountType
      portalType
      domain
      magicEmailAddress
      lms
      isLenderIntegrationSettingsAdmin
      contacts {
        id
        email
        firstName
        lastName
        fullName
        title
        accountId
        dynamicsContactId
        vendorContactRole
        status
      }
    }

    userProfile {
      id
      firstName
      lastName
      fullName
      mugshot
      phoneNumber
      vendorContactRole
      email
      dynamicsContactId
      mobilePhoneNumber
      portalType
      title
      status
      lastLogin
      locationId
      adminRole
      isDemoMode
      lenderContactRole
    }
    vendorProfile {
      id
      name
      dynamicsId
      logo
      showPrequal
      showPortalCreditApp
      showDocMgt
      showLenderDocsAccessMgmt
      showCreditApp
      showPsOptions
      showMarginTool
      showLenderSubmission
      industryGroupType
      role
      showChat
      showTasks
      showRouteOneApp
      showPqt
      creditSubmissionDisplay
      altLanguageOca
      showProposal
      showAftermarketOptions
      allowSyndication
      docusignDocMgmt
      defaultOcaContact
      softPullInDealerPortal
      ofacRedFlagComplianceAccess
      multiLocationManagement
      dlRequired
      dlUploadRequired
      ocaForm
      ocaDocUpload
      amountRequested
      ownershipRequirement
      industryGroupType
      fastTrackSetting
      markupDealer
      styles
      ofacRedFlagComplianceAccess
      territoryManagement
      lenderMatrixAccess
      hasLenderOcaAccess
      hasLenderFinanceProposalsAccess
      proposalMenuAccess
      logoColors
      daysToCreditAppRecertification
      requireCreditAppRecertification
      autoUpdateStageOnSubmissionApproval
      ocaAutofillSettings
      ocaShowCookieConsentBanner
      creditPullSettings {
        vendorProfileCreditPullSettingsId
        vendorProfileId
        autoPull
        creditBureauType
      }
      settingBusinessCreditReportPullInDealerPortal
      ocaDefaultContactInfo {
        id
        email
        dynamicsContactId
        firstName
        lastName
        fullName
        title
        phoneNumber
        mobilePhoneNumber
      }
      creditProducts {
        productId
        productHeader
        productName
        lenderProgramId
        inputRequirements
      }
      lenderProfiles {
        id
        hasActiveUser
        lenderName
        lenderLogo
        showCustomApp
        draftApplicationsEnabled
        pdfTemplate
        submissionMethod
        lenderProfileId
        lenderAccountId
        lenderContactId
        lenderChannelCode
        lenderTypeCode
        dealerRelationship
        submissionReviewShowMappingModal # ON_DISPLAYS_MAPPING_MODAL | OFF_NO_REVIEW_SHOWN
        insuranceRequirements
        isDisabled
        isEnhancedSubmissionsFlowEnabled
        lenderUserProfile {
          id
          email
          dynamicsContactId
          firstName
          lastName
          fullName
          phoneNumber
          mobilePhoneNumber
          mugshot
          title
          accountId
        }
        lenderAccount {
          id
          dynamicsAccountId
          vendorProfileId
          primaryContactId
          name
          address
          phone
          primaryContactName
          primaryContactPhone
          primaryContactEmail
        }
      }
    }
    accountRep {
      fullName
      email
      phoneNumber
      mugshot
    }
  }
`;

const Q_DEALER_RELATED_USERS = gql`
  query RelatedUsers($accountId: ID) {
    relatedUsers(accountId: $accountId) {
      id
      dynamicsContactId
      email
      firstName
      lastName
      fullName
      phoneNumber
      mobilePhoneNumber
      mugshot
      availability
      vendorContactRole
      title
      accountId
      status
    }
  }
`;

const Q_LENDER_RELATED_USERS = gql`
  query LendersRelatedUsers($dynamicsId: ID!) {
    lendersRelatedUsers(dynamicsId: $dynamicsId) {
      id
      dynamicsContactId
      email
      firstName
      lastName
      fullName
      availability
      vendorContactRole
      mobilePhoneNumber
      title
      accountId
      phoneNumber
      mugshot
      account {
        id
        name
      }
    }
  }
`;

const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile($entityId: String!, $fieldsObj: AdminUpdateUserProfileInput!) {
    adminUpdateUserProfile(entityId: $entityId, fieldsObj: $fieldsObj) {
      id
    }
  }
`;

const Q_LENDER_PROFILE = gql`
  query {
    lenderProfile {
      id # Dynamics ID
      lenderProfileId # Postgres ID
      name
      dynamicsContactSubmission
      logo
      showCustomApp
      pdfTemplate
      isEnhancedSubmissionsFlowEnabled
      fdrContact {
        dynamicsContactId
        fullName
      }
    }
  }
`;

const GET_USER_LOGIN_META = gql`
  query GetUserProfileLoginInfoAndStatus {
    userProfile {
      status
      lastLogin
      firstLogin
      dynamicsContactId
    }
  }
`;

export const appApi = {
  getAccount: GET_ACCOUNT,
  getLenderProfile: Q_LENDER_PROFILE,
  getUserLoginMeta: GET_USER_LOGIN_META,
  updateUserProfile: UPDATE_USER_PROFILE,
  getDealerRelatedUsers: Q_DEALER_RELATED_USERS,
  getLenderRelatedUsers: Q_LENDER_RELATED_USERS,
};
